import {Stack, Typography} from '@mui/material'
import {useTranslation} from 'react-i18next'

import {WORK_ORDERS_WIDGET_NAMESPACE} from '../consts'

type Props = {
  overdue: number
  totalOverdue: number
  timeRangeLabel: string
}

export const WorkOrdersOverdueTooltipTitle = ({overdue, totalOverdue, timeRangeLabel}: Props) => {
  const {t} = useTranslation(WORK_ORDERS_WIDGET_NAMESPACE)

  return (
    <Stack spacing={0.5}>
      <Typography fontWeight="medium">
        {`${totalOverdue} ${t('workOrdersOverdueTooltip.label.overdue')} (${t(
          'workOrdersOverdueTooltip.label.allTime'
        )})`}
      </Typography>
      <Typography>{`${overdue} ${t(
        'workOrdersOverdueTooltip.label.overdue'
      )} (${timeRangeLabel})`}</Typography>
    </Stack>
  )
}
